var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup427320024(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    rx: 2.5,
    fill: "#EF4D39"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9433 11.5C10.7955 11.5 10.6565 11.4423 10.5501 11.3374L7.74994 8.53578L4.94982 11.3359C4.84485 11.4409 4.70588 11.4985 4.55656 11.4985C4.40724 11.4985 4.26827 11.4409 4.16183 11.3344C3.94598 11.1186 3.94598 10.7652 4.16183 10.5479L6.96342 7.74926L4.1633 4.94914C3.94746 4.73182 3.94746 4.37847 4.1633 4.16263C4.26827 4.05766 4.40872 4 4.55656 4C4.7044 4 4.84485 4.05766 4.94982 4.16263L7.74994 6.96422L10.5515 4.16263C10.6565 4.05766 10.7955 4 10.9448 4C11.0941 4 11.2331 4.05766 11.3381 4.16263C11.5539 4.37847 11.5539 4.73182 11.3381 4.94914L8.53498 7.74926L11.3351 10.5494C11.5509 10.7667 11.5509 11.12 11.3351 11.3359C11.2301 11.4409 11.0897 11.4985 10.9418 11.4985L10.9433 11.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup427320024);
export default __webpack_public_path__ + "static/media/Group 427320024.97feaedab761fa56ebc277c9b1317d6b.svg";
export { ForwardRef as ReactComponent };